import { render, staticRenderFns } from "./SubscriptionCrypto.vue?vue&type=template&id=bd049a70&scoped=true&"
import script from "./SubscriptionCrypto.vue?vue&type=script&lang=js&"
export * from "./SubscriptionCrypto.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionCrypto.vue?vue&type=style&index=0&id=bd049a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd049a70",
  null
  
)

export default component.exports